// extracted by mini-css-extract-plugin
module.exports = {"container":"oops-view__container___2jAzd","message":"oops-view__message___2s3tm"};